import { Carousel } from 'bootstrap';

/**
 * Bootstrap-karusell som bara ska vara aktiv på mobil. Instanserna rivs och
 * återskapas vid breakpoint-byte, annars ligger karusellen kvar och cyklar på
 * desktop där layouten visar alla slides samtidigt.
 *
 * Ersätter FrontendSrc/patternlab/js/carousel-custom.js.
 */
const MOBILE_QUERY = 'only screen and (max-width: 768px)';

export function initMobileCarousel(): void {
    let carousels: Carousel[] = [];

    const sync = (): void => {
        carousels.forEach(c => c.dispose());
        carousels = [];

        if (!window.matchMedia(MOBILE_QUERY).matches) return;

        carousels = Array.from(document.querySelectorAll<HTMLElement>('.mobile-carousel'))
            .map(el => {
                const carousel = new Carousel(el, { interval: 6000, wrap: true });
                carousel.cycle();
                return carousel;
            });
    };

    sync();

    // matchMedia-lyssnare i stället för resize + debounce: den här bryr sig bara
    // om breakpoint-övergången, inte om varje pixel under en fönsterdragning.
    window.matchMedia(MOBILE_QUERY).addEventListener('change', sync);
}
